import { FRIST_APPROVAL_KIND, type ApprovalFristPayload } from './fristApprovalTypes';

function readString(raw: Record<string, unknown>, ...keys: string[]): string {
  for (const key of keys) {
    const v = raw[key];
    if (typeof v === 'string' && v.trim()) return v.trim();
  }
  return '';
}

/** Parst n8n/ARKO-Antwort auf strukturierte Approval-Frist (Slice 1). */
export function parseApprovalFristFromPayload(payload: unknown): ApprovalFristPayload | null {
  if (!payload || typeof payload !== 'object') return null;
  const root = payload as Record<string, unknown>;

  const nested =
    root.approvalFrist ??
    root.approval_frist ??
    (root.messageKind === 'approval_frist' ? root : null);

  const raw = (nested && typeof nested === 'object' ? nested : root) as Record<string, unknown>;

  const approvalKind = readString(raw, 'approval_kind');
  const messageKind = readString(root, 'messageKind');
  if (approvalKind && approvalKind !== FRIST_APPROVAL_KIND) return null;
  if (!approvalKind && messageKind !== 'approval_frist') return null;

  const card_id = readString(raw, 'card_id');
  if (!card_id) return null;

  const frist_typ_vorschlag = readString(raw, 'frist_typ_vorschlag', 'frist_typ');
  const start_datum = readString(raw, 'start_datum');
  const ende_vorschau = readString(raw, 'ende_vorschau', 'ende_datum');
  const kalender_trace = readString(raw, 'kalender_trace');

  if (!frist_typ_vorschlag || !start_datum || !ende_vorschau) return null;

  return {
    card_id,
    approval_kind: FRIST_APPROVAL_KIND,
    frist_typ_vorschlag,
    start_datum,
    ende_vorschau,
    kalender_trace,
    regel_id: readString(raw, 'regel_id') || undefined,
    motor_audit_id: readString(raw, 'motor_audit_id') || undefined,
    akte_nc_path: readString(raw, 'akte_nc_path') || undefined,
    quell_dokument_nc_path: readString(raw, 'quell_dokument_nc_path') || undefined,
    quell_dokument_display_name: readString(raw, 'quell_dokument_display_name') || undefined,
    quell_dokument_pb_id: readString(raw, 'quell_dokument_pb_id') || undefined,
    begruendung_kurz: readString(raw, 'begruendung_kurz') || undefined,
  };
}
